import { JsonValue } from '../serializable';
import { WorkflowNodeType } from './types';
import { WorkflowNode, resolveNoWorkflow } from './workflow-node';

type WorkflowRunDefinitionNodeData = {
  runNodeId: string;
  sourceNodeId: string | null;
  runId: string;
  workflowId: string;
  ownerId: string;
  ownerOrgId: string;
  type: WorkflowNodeType;
  data: JsonValue;
  inputShape: string | null;
  defaultOutput: JsonValue | null;
  createdAt: Date;
  updatedAt: Date;
};

export class WorkflowRunDefinitionNode {
  private constructor(
    private readonly snapshot: WorkflowRunDefinitionNodeData
  ) {}

  static fromRow(row: {
    run_node_id: string;
    source_node_id: string | null;
    run_id: string;
    workflow_id: string;
    owner_id: string;
    owner_org_id: string;
    type: WorkflowNodeType;
    data: JsonValue;
    input_shape: string | null;
    default_output: JsonValue | null;
    created_at: Date;
    updated_at: Date;
  }): WorkflowRunDefinitionNode {
    return new WorkflowRunDefinitionNode({
      runNodeId: row.run_node_id,
      sourceNodeId: row.source_node_id,
      runId: row.run_id,
      workflowId: row.workflow_id,
      ownerId: row.owner_id,
      ownerOrgId: row.owner_org_id,
      type: row.type,
      data: row.data,
      inputShape: row.input_shape,
      defaultOutput: row.default_output,
      createdAt: row.created_at,
      updatedAt: row.updated_at,
    });
  }

  get runNodeId(): string {
    return this.snapshot.runNodeId;
  }

  get sourceNodeId(): string | null {
    return this.snapshot.sourceNodeId;
  }

  get workflowId(): string {
    return this.snapshot.workflowId;
  }

  get type(): WorkflowNodeType {
    return this.snapshot.type;
  }

  get data(): JsonValue {
    return this.snapshot.data;
  }

  get name(): string {
    return this.toWorkflowNode().name;
  }

  toWorkflowNode(): WorkflowNode {
    return WorkflowNode.fromSerialized(
      {
        id: this.snapshot.runNodeId,
        ownerId: this.snapshot.ownerId,
        ownerOrgId: this.snapshot.ownerOrgId,
        workflowId: this.snapshot.workflowId,
        type: this.snapshot.type,
        data: this.snapshot.data,
        inputShape: this.snapshot.inputShape,
        defaultOutput: this.snapshot.defaultOutput,
        inputFromNodeId: null,
        createdAt: this.snapshot.createdAt.toISOString(),
        updatedAt: this.snapshot.updatedAt.toISOString(),
      },
      { loadWorkflow: resolveNoWorkflow }
    );
  }
}
